class Storage {
    constructor () {
        this.remainingStorage = 0;
    }

    get () {
        return this.remainingStorage;
    }

    set (value) {
        this.remainingStorage = value;
    }
}

export const storage = new Storage();
